module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0035.jpg?v=4d2a3e06";